import { useAppSelector } from "../../../redux/hooks/redux";
import { AccessDecision } from "../AccessGate.types";
import { decodeToken } from "../../../utils";

export const PAGE_BUILDER_ACCESS_REASONS = {
    NOT_AUTHENTICATED: "NOT_AUTHENTICATED",
    NO_COMPANY: "NO_COMPANY",
} as const;

export const usePageBuilderAccessStrategies = (): AccessDecision[] => {
    const token = sessionStorage.getItem("token");
    const { uid, company, companies } = useAppSelector((state) => state.userState);
    const tokenUser: any = token ? decodeToken(token) : null; //Change the any type to an interface

    const hasToken = Boolean(token);
    // Decode token as a fallback because Redux user state may hydrate after route render.
    const hasAccount = Boolean(uid || tokenUser?.uid);
    const hasCompany = Boolean(company?.id);

    return [
        // Ordered from broadest prerequisite to most specific entitlement.
        {
            granted: hasToken && hasAccount,
            reason: PAGE_BUILDER_ACCESS_REASONS.NOT_AUTHENTICATED,
            meta: { hasToken, hasAccount, uid },
        },
        {
            granted: hasCompany,
            reason: PAGE_BUILDER_ACCESS_REASONS.NO_COMPANY,
            meta: { company, companiesCount: companies?.length ?? 0 },
        },
    ];
};
